import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Register from './pages/Register';
import Login from './pages/Login';
import Profile from './pages/Profile'; // Novo componente adicionado
import AddMatch from './pages/AddMatch';
import Predictions from './pages/Predictions';
import MyPredictions from './pages/MyPredictions';
import Campeonatos from './pages/Campeonatos';
import AddCampeonato from './pages/AddCampeonato';
import AddTime from './pages/AddTime';
import MatchesList from './pages/MatchesList';
import TimesList from './pages/TimesList';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import './styles.css';

function App() {
  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/campeonatos"
            element={
              <ProtectedRoute>
                <Campeonatos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/matches/:campeonatoId"
            element={
              <ProtectedRoute adminOnly={true}>
                <MatchesList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/times"
            element={
              <ProtectedRoute adminOnly={true}>
                <TimesList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-campeonato"
            element={
              <ProtectedRoute adminOnly={true}>
                <AddCampeonato />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-match"
            element={
              <ProtectedRoute adminOnly={true}>
                <AddMatch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-time"
            element={
              <ProtectedRoute adminOnly={true}>
                <AddTime />
              </ProtectedRoute>
            }
          />
          <Route
            path="/predictions/:campeonatoId"
            element={
              <ProtectedRoute>
                <Predictions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-predictions"
            element={
              <ProtectedRoute>
                <MyPredictions />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;